import React from 'react';
import {
  compose,
  setDisplayName,
  withProps,
  defaultProps,
} from 'recompose';
import reactCSS from 'reactcss';
import CookieToggle from '../cookie-toggle';
import { Map } from '@ux/render-logic';
import { Row, Column } from '@ux/grid';
import { getStyles } from '@ux/style-utils';
import stylesheet from './CookieToggleGroup.stylesheet';

const stylesheetToStyles = (stylesheet, props) => reactCSS(stylesheet, {
  tablet: props.isMinMd,
});

export const PureCookieToggleGroup = ({
  theme,
  cookies,
  styles,
  xsCols,
  mdCols,
  lgCols,
}) => (
  <div style={styles.root}>
    <Row theme={theme}>
      <Map
        collection={cookies}
        fn={(cookie) => (
          <Column
            key={cookie.name}
            theme={theme}
            xs={xsCols}
            md={mdCols}
            lg={lgCols}
          >
            <div style={styles.item}>
              <CookieToggle
                theme={theme}
                name={cookie.name}
                canOptOut={cookie.optOut}
              />
            </div>
          </Column>
        )}
      />
    </Row>
  </div>
);

export const enhance = compose(
  setDisplayName('CookieToggleGroup'),
  defaultProps({
    xsCols: 12,
    mdCols: 6,
    lgCols: 3,
  }),
  withProps((ownerProps) => ({
    styles: getStyles(stylesheet, stylesheetToStyles, ownerProps),
  })),
);

export default enhance(PureCookieToggleGroup);



// WEBPACK FOOTER //
// ./src/presentation/components/cookie-toggle-group/CookieToggleGroup.js